import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
    classes: [],
    subjectsClasses: [],
    exerciseFilter: {},
    exerciseDetail: {},
    question_exercise: [],
    question_exercise_info: {},
    open_math: {},
    math_value: null,
    validate_question: {},
    question_activity: {},
    check_answer: false,
    question_valid_data: [],
    allClasses: [],
    getExerciseDetailNumber: [],
    getPracticeType: [],
    getLisstPracticeTypeBook: [],
    getActive: 0,
    practiceActive: {},
    practiceTypes: [],
    exerciseClassCurr: {},
    questionsExercise: {},
    bookIndexOfBook: [],
    paramsFilterExExam: {classId : 1, subjectId: 0, typeId: 0, keyword: '', pageIndex: 1, pageSize: 12, sort: '', direction: ''},
    paramsFilterExOtherThematic: {classId : 1, subjectId: 0, type: 0},
    ebooksDetail: {},
    paramSearchRelateMedia: { bookId: 0, pageNo: 0, typeId: 0, pageIndex: 0, pageSize: 6 },
    infoQuestionPreview: {},
    catsFlatForExercise: []
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};